import axios from 'axios'
import Utile from '@/utile/utile'
import qs from 'qs'

export default (store) => {
  // ... setup subscriptions, whatever else you need to initialize
  store.requestData = (url, data, header) => {
    return new Promise((resolve, reject) => {
      axios.post(Utile.getRestUrl() + url, qs.stringify(data), Utile.getAxiosConfig(header)).then(result => {
        // 토큰 설정
        console.log('log:', result)
        store.commit('auth/setToken', { token: result.data.token }, { root: true })
        // 어레이 반환
        resolve(result.data)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/plugins/utile.js